<template>
	<fieldset class="fieldset">
		<div class="form-row">
			<field-box name="investment[investment_type]" :label="$t('forms.investment_type')" type="select" :options="investmentTypeOptions" :disabled="disabled" :has-error="errors?.['investment.investment_type']?.length"/>
		</div>
	</fieldset>
</template>

<script>

import DefaultFieldBox from "@/components/form-fields/DefaultFieldBox.vue";
import FieldBox from "@/components/form-fields/FieldBox.vue";

export default {
	name: "PropertyInvestmentFieldset",
	props: ['data', 'disabled', 'errors'],
	components: {
		DefaultFieldBox,
		FieldBox
	},
	computed: {
		investmentTypeOptions(){
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 'stocks',
					title: this.$t('forms.investment_type_stocks')
				},
				{
					value: 'bonds',
					title: this.$t('forms.investment_type_bonds')
				},
				{
					value: 'funds',
					title: this.$t('forms.investment_type_funds')
				},
				{
					value: 'crypto',
					title: this.$t('forms.investment_type_crypto')
				},
				{
					value: 'other',
					title: this.$t('forms.investment_type_other')
				}
			];

			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.investment_type) {
						item.selected = true;
					}
				});
			}

			return options;
		}
	}
}
</script>

<style scoped lang="scss">
fieldset {
	padding: 0;
	margin-inline: 0;
	padding-block: 0;
	padding-inline: 0;
	border: none;
	margin: 0 0 15px;
	&:last-child {
		margin-bottom: 0;
	}
}


.form-row {
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&.two-columns {
		display: flex;
		justify-content: space-between;
		flex-direction: row;

		.field-box {
			width: calc(50% - 8px);
		}
	}
}

@media($mobileS) {
	.form-row {
		margin-bottom: 10px;

		&.two-columns {
			flex-direction: column;

			.field-box {
				width: 100%;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

</style>